/* eslint-disable */
/* global Swiper */
webpackJsonp([0],{

	/***/ 26:
	/***/ (function(module, exports, __webpack_require__) {

		"use strict";

		var _hero = __webpack_require__(2);

		var _hero2 = _interopRequireDefault(_hero);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		(0, _hero2.default)();

	/***/ }),
	/***/ 41:
	/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

	/***/ }),
	/***/ 80:
	/***/ (function(module, exports, __webpack_require__) {

		__webpack_require__(26);
		module.exports = __webpack_require__(41);


	/***/ })

	},
[80]);

/* eslint-enable */

/*
 * Swiper for customer quotes in hero
 */
(function () {
	"use strict";

	new Swiper('.q-default-hero__box-wrap .swiper-container', {
		// Optional parameters
		loop: true,

		// If we need pagination
		pagination: {
			el: '.q-default-hero__box-wrap .swiper-pagination',
			clickable: true
		},
		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
			pauseOnMouseEnter: true
		},
	});

	// init news and events carousel
	new Swiper(".resources .resources-slider-container", {
		slidesPerView: "auto",
		navigation: false,
		pagination: {
			el: '.resources .swiper-pagination',
			type: 'bullets',
		},
		centeredSlides: false,
		spaceBetween: 30
	});

	// init SaaSDR apps icons slider
	new Swiper(".saasdr-apps-slider", {
		slidesPerView: 3,
		navigation: false,
		pagination: false,
		centeredSlides: false,
		spaceBetween: 10,
		breakpoints: {
			580: {
				slidesPerView: 2
			},
			400: {
				slidesPerView: 1
			}
		}
	});

}());